import { render, staticRenderFns } from "./TipoConsultaLibroDeQuejas.vue?vue&type=template&id=10535149"
import script from "./TipoConsultaLibroDeQuejas.vue?vue&type=script&lang=js"
export * from "./TipoConsultaLibroDeQuejas.vue?vue&type=script&lang=js"
import style0 from "./TipoConsultaLibroDeQuejas.vue?vue&type=style&index=0&id=10535149&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports